import { createAsyncThunk } from '@reduxjs/toolkit';
import { IUser } from 'bg-server/src/components/api/v1/user/types';

import { loginSvc, getUserMeSvc, logoutSvc, acceptLegalSvc } from '../../services/user';
import { setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export interface ILoginData { email?: string; password?: string; isRememberme?: boolean; otp?: string; }
export const login = createAsyncThunk<IUser, ILoginData, { state: ICoreState }>('auth/login', async (data, thunkAPI) => {
    const { getState, requestId, dispatch } = thunkAPI;
    try {
        const { currentRequestId, isLoggingIn } = getState().user;
        if (!isLoggingIn || requestId !== currentRequestId) {
            return null;
        }

        const { email = '', password = '', isRememberme = false, otp = null } = data;
        dispatch(setLoadingStatus(true));
        const user = await loginSvc(email, password, isRememberme, otp);
        dispatch(setLoadingStatus(false));
        return user;
    } catch (error) {
        dispatch(setLoadingStatus(error.message || error));
        throw error;
    }
});

export const logout = createAsyncThunk<void, void, { state: ICoreState }>('auth/logout', async (_data, thunkAPI) => {
    const { getState, requestId, dispatch } = thunkAPI;
    try {
        const { currentRequestId, isLoggingIn } = getState().user;
        if (!isLoggingIn || requestId !== currentRequestId) {
            return;
        }

        dispatch(setLoadingStatus(true));
        await logoutSvc();
        dispatch(setLoadingStatus(false));
    } catch (error) {
        dispatch(setLoadingStatus(error.message || error));
        throw error;
    }
});

export const verifyLoggedIn = createAsyncThunk<IUser, void, { state: ICoreState }>('auth/verifyLoggedIn', async (_data, thunkAPI) => {
    const { getState, requestId, dispatch } = thunkAPI;
    try {
        const { isLoggingIn, currentRequestId } = getState().user;
        // Quan arribem aquí ja hem passat pel .pending del reducer
        // El .pending posa el isLoggingIn a true i el currentRequestId a requestId
        // per tant, si no estem fent login o el currentRequestId != requestId, vol dir que s'ha iniciat una altra petició
        if (!isLoggingIn || requestId !== currentRequestId) {
            return null;
        }
        dispatch(setLoadingStatus(true));
        const userMe = await getUserMeSvc();
        dispatch(setLoadingStatus(false));
        return userMe;
    } catch (error) {
        dispatch(setLoadingStatus(error.message || error));
        throw error;
    }
});

export const acceptLegal = createAsyncThunk<IUser, void, { state: ICoreState }>('auth/acceptLegal', async (_data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            throw new Error('User not logged in');
        }
        dispatch(setLoadingStatus(true));
        const userMe = await acceptLegalSvc();
        dispatch(setLoadingStatus(false));
        return userMe;
    } catch (error) {
        dispatch(setLoadingStatus(error.message || error));
        throw error;
    }
});

// TODO: get another user --> una possibilitat és crear un reducer userManager i allà carregar els altres usuaris
// export interface UserGetAction extends Action { user: IUser; type: TypeKeys.USER_GET; }
// const getUserDispatcher = (user: IUser): UserGetAction => ({ user, type: TypeKeys.USER_GET });

// export declare type GetUserThunkAct = (userId: string) => ThunkAction<Promise<void>, ICoreState, void, AnyAction>;
// export const getUser: GetUserThunkAct = (userId: string) => async (dispatch) => {
//     try {
//         const user: IUser = await getUserSvc(userId);
//         dispatch(getUserDispatcher(user));
//     } catch (error) {
//         dispatch(setLoadError(error));
//     }
// };

// export interface UserUpdateAction extends Action { user: IUser; type: TypeKeys.USER_UPDATE; }
// export const updateUserAction = (user: IUser): UserUpdateAction => ({ user, type: TypeKeys.USER_UPDATE });

// export declare type UserUpdateThunkAct = (userId: string, userData: IUser) => ThunkAction<Promise<void>, ICoreState, void, AnyAction>;
// export const updateUser: UserUpdateThunkAct = (userId: string, userData: IUser) => async (dispatch) => {
//     try {
//         dispatch(setLoading());
//         const userUpdated = await updateUserSvc(userId, userData);
//         dispatch(updateUserAction(userUpdated));
//         dispatch(setLoadsuccess());
//     } catch (error) {
//         dispatch(setLoadError(error));
//     }
// };
